






















import Vue from 'vue'

export default Vue.extend({
  name: 'StringInput',
  props: {
    name: {},
    value: String,
    placeholder: {},
    suffixIcon: {},
    readOnly: {type: Boolean, default: false},
    required: {type: Boolean, default: false},
    type: String,
    rows: {
      type: Number,
      default: 3
    }
  },
  methods: {
    onBlur (event: UIEvent) {
      this.$emit('blur', event)
    },
    onInput (event: string) {
      this.$emit('input', event)
    }
  },
  computed: {
    currentValue: {
      get (): string {
        return this.value || ''
      },
      set () {
      }
    }
  }
})
